import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { WrapAssessmentDefs, WrapCreateSet, WrapContent } from './Style'
import { Page } from 'pages'
import { AssessmentDefs } from 'pages'
import { CustomSection, WrapAll } from 'styles/GlobalStyle'
import { CreateSet } from 'pages/School/CreateAssessments'
import { isEmpty } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { actions } from 'store'
import { useDispatch } from 'react-redux'

const CreateAssessments = () => {
    const { selectedTestTakers } = useSelector(state => state.testTaker)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (isEmpty(selectedTestTakers))
            navigate(app.testTakers)

        return (() => {
            dispatch(actions.setSelectedAssessmentDefs([]))
            dispatch(actions.setSelectedTestTakers([]))
        })
    }, [])

    return (
        <Page>
            <WrapAll>
                <WrapContent>
                    <WrapAssessmentDefs>
                        <AssessmentDefs selectAssessment multiple onSelectAssessment={() => { }} />
                    </WrapAssessmentDefs>
                    <WrapCreateSet>
                        <CustomSection $bg>
                            <CreateSet />
                        </CustomSection>
                    </WrapCreateSet>
                </WrapContent>
            </WrapAll>
        </Page>
    )
}

export default CreateAssessments